// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "flight-3rpUh";
var _4 = "flight_selected-13FQU";
var _5 = "readonly-3KA2u";
export { _1 as "__esModule", _2 as "tablet", _3 as "flight", _4 as "flight_selected", _5 as "readonly" }
export default { "__esModule": _1, "tablet": _2, "flight": _3, "flight_selected": _4, "readonly": _5 }
